import React from 'react'
import { Typography } from '@mui/material'
import FloatingCardIcon from './FloatingCardIcon'
import Heading from './Heading'

const SingleIconTile = ({
  icon,
  iconAlt,
  headingText,
  bodyText
}: {
  icon: string
  iconAlt: string
  headingText: string
  bodyText: string
}) => {
  return (
    <>
      <FloatingCardIcon icon={icon} iconAlt={iconAlt} />
      <div className="tile-text-container">
        <Heading variant="headlineSmall" domElement="h3" text={headingText} />
        <Typography variant="bodyLarge">{bodyText}</Typography>
      </div>
    </>
  )
}

export default SingleIconTile
